<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'study.diningRoomParameters.title.1'"></h2>
        <kiwi-spacer [size]="16"></kiwi-spacer>
        <table>
            <thead>
            <tr class="_titlePartTable">
                <th [i18nKey]="'study.diningRoomParameters.area'"></th>
                <th class="_numberColumn"[i18nKey]="'study.diningRoomParameters.area.1'"></th>
                <th class="_numberColumn"[i18nKey]="'study.diningRoomParameters.area.2'"></th>
                <th class="_numberColumn"[i18nKey]="'study.diningRoomParameters.area.3'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td></td>
                <td class="_number">
                    {{study.workingClassAreaDiningRoomRent | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </td>
                <td class="_number">
                    {{study.averageAreaDiningRoomRent | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </td>
                <td class="_number">
                    {{study.wealthyAreaDiningRoomRent | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </td>
            </tr>
            </tbody>
        </table>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <div class="capacity">
            <span class="capacity-label"[i18nKey]="'study.diningRoomParameters.capacity'"></span>
            <span class="capacity-value">{{study.diningRoomSeatingCapacity}}</span>
        </div>
    </section>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'study.diningRoomParameters.title.2'"></h2>
        <kiwi-spacer [size]="16"></kiwi-spacer>
        <table>
            <thead>
            <tr class="_titlePartTable">
                <th [i18nKey]="'study.diningRoomParameters.layout'"></th>
                <th class="_numberColumn"[i18nKey]="'study.diningRoomParameters.furniture'"></th>
                <th class="_numberColumn"[i18nKey]="'study.diningRoomParameters.tableware'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td></td>
                <td class="_number">
                    {{study.furnitureValueDepreciationPeriodLength}}
                </td>
                <td class="_number">
                    {{study.silverwareValueDepreciationPeriodLength}}
                </td>
            </tr>
            </tbody>
        </table>
    </section>

    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'study.diningRoomParameters.title.3'"></h2>

        <p>{{labelKeyOrLoremIpsum('study.diningRoomParameters.paragraph.1') | translate}}
            {{labelKeyOrLoremIpsum('study.diningRoomParameters.paragraph.2') | translate}}</p>

        <table>
            <thead>
            <tr class="_titlePartTable">
                <th [i18nKey]="'study.diningRoomParameters.budget'"></th>
                <th class="_numberColumn"[i18nKey]="'study.diningRoomParameters.budget.1'"></th>
                <th class="_numberColumn"[i18nKey]="'study.diningRoomParameters.budget.2'"></th>
                <th class="_numberColumn"[i18nKey]="'study.diningRoomParameters.budget.3'"></th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td></td>
                <td class="_number">
                    {{study.standardMaintenanceBudgetPerRoom / 2 | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </td>
                <td class="_number">
                    {{study.standardMaintenanceBudgetPerRoom | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </td>
                <td class="_number">
                    {{study.standardMaintenanceBudgetPerRoom * 2 | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'study.diningRoomParameters.quality.note'"></td>
                <td class="_number">50</td>
                <td class="_number">67</td>
                <td class="_number">80</td>
            </tr>
            </tbody>
        </table>
    </section>

    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'study.diningRoomParameters.title.4'"></h2>
        <p>{{labelKeyOrLoremIpsum('study.diningRoomParameters.paragraph.3') | translate}}</p>
        <p>{{labelKeyOrLoremIpsum('study.diningRoomParameters.paragraph.4') | translate}}</p>
    </section>

    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'study.diningRoomParameters.title.5'"></h2>
        <p>{{labelKeyOrLoremIpsum('study.diningRoomParameters.paragraph.5') | translate}}</p>
    </section>
</div>
